/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Add';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const AddIcon = withMuiAdapter(Base, 'Add');
